import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

export const PUT_PROJECT_COST_RATES = gql`
  mutation putProjectCostRates(
    $projectId: String!
    $dimensionUris: [String!]
    $requiredDimensionUris: [String!]
    $rates: [ProjectRateInput3!]
  ) {
    putProjectCostRates(
      projectId: $projectId
      dimensionUris: $dimensionUris
      requiredDimensionUris: $requiredDimensionUris
      rates: $rates
    ) {
      id
      dimensions {
        dimensionUri
        objectUri
      }
      scheduleEntries {
        amount {
          amount
          currency {
            id
          }
        }
      }
    }
  }
`;

const mapProjectRatesToCostRateInput = (selectedDimensions, projectRates) => {
  const groupMap = projectRates.reduce((acc, rate) => {
    const { groupId } = rate;

    if (!acc[groupId]) {
      acc[groupId] = [];
    }
    acc[groupId].push(rate);

    return acc;
  }, {});

  return Object.values(groupMap).map(groupRates => {
    const firstRate = groupRates[0];
    const dimensions = selectedDimensions
      .filter(d => firstRate[d.id]?.value)
      .map(d => ({
        dimensionUri: d.id,
        objectUri: firstRate[d.id].value.id
      }));

    const entries = groupRates.map(rate => ({
      amount: {
        amount: rate.amount?.amount || 0,
        currency: { id: rate.amount?.currency?.id }
      },
      effectiveDate: rate.effectiveDate
    }));

    return { dimensions, entries };
  });
};

export const usePutProjectCostRates = () => {
  const [putProjectCostRatesMutation, { loading }] = useMutation(
    PUT_PROJECT_COST_RATES
  );

  return {
    putProjectCostRates: async ({
      projectId,
      selectedDimensions,
      projectRates
    }) => {
      const rates = mapProjectRatesToCostRateInput(
        selectedDimensions,
        projectRates
      );

      return putProjectCostRatesMutation({
        variables: {
          projectId,
          dimensionUris: selectedDimensions.map(d => d.id),
          requiredDimensionUris: [],
          rates
        }
      });
    },
    isSaving: loading
  };
};
